(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5003],{

/***/ 3076:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/tag/[tagUrlId]",
      function () {
        return __webpack_require__(69348);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _tagUrlId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/lodash-es/flatten.js
var flatten = __webpack_require__(27961);
// EXTERNAL MODULE: ./node_modules/lodash-es/floor.js + 1 modules
var floor = __webpack_require__(34426);
// EXTERNAL MODULE: ./utils/api/hooks/useKeywords.js
var useKeywords = __webpack_require__(59776);
;// CONCATENATED MODULE: ./utils/api/hooks/useKeywordByUrlId.js

const useKeywordByUrlId = function() {
    let keywordUrlId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, swrOptions = arguments.length > 1 ? arguments[1] : void 0;
    const { data: keywords , ...rest } = (0,useKeywords/* useKeywords */.N)(()=>keywordUrlId ? {
            urlId: keywordUrlId
        } : null, swrOptions);
    return {
        data: keywords === null || keywords === void 0 ? void 0 : keywords[0],
        ...rest
    };
};

// EXTERNAL MODULE: ./utils/api/hooks/useInfiniteArticles.js
var useInfiniteArticles = __webpack_require__(68138);
// EXTERNAL MODULE: ./utils/api/hooks/useBanners.js
var useBanners = __webpack_require__(13929);
// EXTERNAL MODULE: ./utils/api/hooks/useArticleCount.js
var useArticleCount = __webpack_require__(43921);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./utils/native-notifier.js
var native_notifier = __webpack_require__(11634);
// EXTERNAL MODULE: ./components/common/Layout/index.js
var Layout = __webpack_require__(82023);
// EXTERNAL MODULE: ./components/common/Header/index.js + 2 modules
var Header = __webpack_require__(75883);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./components/common/ArticleListItem/index.js + 1 modules
var ArticleListItem = __webpack_require__(70650);
// EXTERNAL MODULE: ./components/common/TagButton/index.js
var TagButton = __webpack_require__(25133);
// EXTERNAL MODULE: ./components/common/InfiniteContainer/index.js
var InfiniteContainer = __webpack_require__(26643);
// EXTERNAL MODULE: ./components/common/ArticleClassifications/index.js
var ArticleClassifications = __webpack_require__(94782);
// EXTERNAL MODULE: ./components/common/LatestArticle/index.js
var LatestArticle = __webpack_require__(87624);
// EXTERNAL MODULE: ./components/common/Hidden/index.js
var Hidden = __webpack_require__(18450);
// EXTERNAL MODULE: ./components/common/Divider/index.js
var Divider = __webpack_require__(20293);
// EXTERNAL MODULE: ./components/common/GuessLikesList/index.js + 2 modules
var GuessLikesList = __webpack_require__(26710);
// EXTERNAL MODULE: ./components/common/Banner/index.js
var Banner = __webpack_require__(25820);
// EXTERNAL MODULE: ./components/common/Footer/index.js + 12 modules
var Footer = __webpack_require__(56007);
;// CONCATENATED MODULE: ./components/pages/Article/SearchByTag/index.js

























const SearchByTag = (param)=>{
    let { fallbackData  } = param;
    var _router_query;
    const router = (0,next_router.useRouter)();
    const { data: keyword  } = useKeywordByUrlId((_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.tagUrlId, {
        fallbackData: [
            fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.keyword
        ]
    });
    const { data , size , setSize  } = (0,useInfiniteArticles/* useInfiniteArticles */.g)(()=>({
            keywordId: keyword._id
        }), {
        fallbackData: [
            fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.articles
        ]
    });
    const articles = (0,flatten/* default */.Z)(data);
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const { data: advertisementBanner  } = (0,useBanners/* useBanners */.U)(webview === null || webview === void 0 ? void 0 : webview.name, {
        displayAt: "articleListAdvertisement"
    });
    const bannerList = (0,flatten/* default */.Z)(advertisementBanner);
    const onLoadMore = ()=>{
        setSize(size + 1);
    };
    const { data: articleCount  } = (0,useArticleCount/* useArticleCount */.T)(()=>({
            keywordId: keyword._id
        }), {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.articleCount
    });
    const containerId = "scrollable-article-container";
    (0,react.useEffect)(()=>{
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
            try {
                (0,native_notifier/* enableNativeHeaderMainTabs */.QL)(false);
                (0,native_notifier/* enableNativeHeaderNavBack */.Gz)(true);
                (0,native_notifier/* enableNativeHeaderSearch */.PP)(false);
            } catch (err) {
                console.error("native notifier error: ", err.message);
            }
        }
    }, [
        webview
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        stickyHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
        fixContentHeight: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfiniteContainer/* default */.Z, {
            id: containerId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "headlineSmall",
                            mt: 8,
                            children: [
                                "共",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "headlineSmall",
                                    color: "primary",
                                    component: "span",
                                    children: articleCount
                                }),
                                " ",
                                "篇文章有 ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TagButton/* default */.Z, {
                                    size: "lg",
                                    children: keyword === null || keyword === void 0 ? void 0 : keyword.name
                                }),
                                " 標籤"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            mt: {
                                xs: 12,
                                lg: 18
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    lg: 8,
                                    pr: {
                                        xxl: 12,
                                        maxLimit: 24
                                    },
                                    px: {
                                        md: 8,
                                        lg: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* default */.Z, {
                                            dataLength: (articles === null || articles === void 0 ? void 0 : articles.length) || 0,
                                            hasMore: true,
                                            next: onLoadMore,
                                            scrollableTarget: containerId,
                                            scrollThreshold: 0.6,
                                            children: [
                                                articles === null || articles === void 0 ? void 0 : articles.map((article, index)=>{
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                mb: {
                                                                    xs: 8,
                                                                    md: 15
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleListItem/* default */.Z, {
                                                                    article: article
                                                                })
                                                            }),
                                                            (index + 1) % 10 === 0 && (bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,floor/* default */.Z)((index + 1) / 10) - 1]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* AdvertisementBanner */.Nt, {
                                                                banner: bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,floor/* default */.Z)((index + 1) / 10) - 1]
                                                            }) : "",
                                                            index === (articles === null || articles === void 0 ? void 0 : articles.length) - 1 && (index + 1) % 10 !== 0 && (bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,floor/* default */.Z)((index + 1) / 10)]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* AdvertisementBanner */.Nt, {
                                                                banner: bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,floor/* default */.Z)((index + 1) / 10)]
                                                            }) : ""
                                                        ]
                                                    }, article._id);
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Solid */.D, {
                                                    mt: {
                                                        xs: 18,
                                                        xl: 24
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestArticle/* default */.Z, {
                                                mt: 12
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    lg: 4,
                                    px: {
                                        md: 8,
                                        lg: 0
                                    },
                                    pl: {
                                        lg: 20,
                                        xl: 24,
                                        xxl: 38,
                                        maxLimit: 41
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleClassifications/* default */.Z, {
                                            mt: {
                                                xs: 12,
                                                lg: 0
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GuessLikesList/* default */.Z, {
                                            keyword: [
                                                keyword._id
                                            ],
                                            mt: 12
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInDesktopBox */.aI, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestArticle/* default */.Z, {
                                                mt: 12
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
            ]
        })
    });
};
/* harmony default export */ var Article_SearchByTag = (SearchByTag);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(73221);
;// CONCATENATED MODULE: ./components/pages/Article/SearchByTag/MetaTags.js



const MetaTags = (param)=>{
    let { resolvedUrl , keyword  } = param;
    const pathName = resolvedUrl.split("?")[0];
    const title = "【".concat(keyword.name, "】相關文章、知識蒐集－信義居家");
    const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "首頁",
                item: "https://livinglife.com.tw"
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "找好文",
                item: "https://livinglife.com.tw/article"
            },
            {
                "@type": "ListItem",
                position: 3,
                name: title,
                item: constants/* LS_APP_DOMAIN */._8 + pathName
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: "".concat(constants/* LS_APP_DOMAIN */._8 + pathName)
            }, "canonical"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }, "title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: "整理各種".concat(keyword.name, "相關介紹文章、知識/常識蒐集，讓你能一覽所有").concat(keyword.name, "相關文章/資訊、信義居家為您注意的居家生活大小事")
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: "整理各種".concat(keyword.name, "相關介紹文章、知識/常識蒐集，讓你能一覽所有").concat(keyword.name, "相關文章/資訊、信義居家為您注意的居家生活大小事")
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: "".concat(constants/* LS_APP_DOMAIN */._8 + pathName)
            }, "og:url"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(breadcrumbData)
                }
            })
        ]
    });
};
/* harmony default export */ var SearchByTag_MetaTags = (MetaTags);

// EXTERNAL MODULE: ./utils/withLivingSinyi.js + 8 modules
var withLivingSinyi = __webpack_require__(93756);
// EXTERNAL MODULE: ./components/common/NoindexRemoval/index.js
var NoindexRemoval = __webpack_require__(84070);
;// CONCATENATED MODULE: ./pages/article/tag/[tagUrlId].js





const SearchByTagPage = (props)=>{
    var _props_fallbackData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoindexRemoval/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchByTag_MetaTags, {
                resolvedUrl: props.resolvedUrl,
                keyword: (_props_fallbackData = props.fallbackData) === null || _props_fallbackData === void 0 ? void 0 : _props_fallbackData.keyword
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Article_SearchByTag, {
                ...props
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _tagUrlId_ = ((0,withLivingSinyi/* default */.Z)(SearchByTagPage));


/***/ }),

/***/ 59776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useKeywords; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useKeywords = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/keywords?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(propsObject));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3829,5897,9072,9477,231,5616,9705,318,168,6102,9531,3756,6245,6007,7266,9542,9507,9774,2888,179], function() { return __webpack_exec__(3076); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);